(() => {
  const stickySelector = '[data-tradepro-sticky-buy]';
  const mainAtcSelector = '[data-tradepro-product-atc]';
  const dynamicCheckoutSelector = '[data-tradepro-dynamic-checkout]';

  const buyNowLabel = document.documentElement.dataset.tradeproBuyNowLabel || (window.KitomasgotaI18n?.text("Buy it now") ?? 'Buy it now');

  const setLocalizedDynamicCheckoutLabel = (scope = document) => {
    scope.querySelectorAll('.shopify-payment-button__button').forEach((button) => {
      const current = (button.textContent || '').trim();
      if (!/buy it now/i.test(current)) return;

      button.querySelectorAll('*').forEach((node) => {
        node.childNodes.forEach((child) => {
          if (child.nodeType === Node.TEXT_NODE && /buy it now/i.test(child.nodeValue || '')) {
            child.nodeValue = child.nodeValue.replace(/buy it now/ig, buyNowLabel);
          }
        });
      });

      button.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE && /buy it now/i.test(child.nodeValue || '')) {
          child.nodeValue = child.nodeValue.replace(/buy it now/ig, buyNowLabel);
        }
      });

      button.setAttribute('aria-label', buyNowLabel);
    });
  };

  const initializeStickyBuy = () => {
    const sticky = document.querySelector(stickySelector);
    if (!sticky || sticky.dataset.tradeproStickyInitialized === 'true') return;

    sticky.dataset.tradeproStickyInitialized = 'true';

    let observer;
    let observedButton;
    let hasBeenVisible = false;

    const hideSticky = () => {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    };

    const showSticky = () => {
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    };

    const bindToMainButton = () => {
      const nextButton = document.querySelector(mainAtcSelector);
      if (!nextButton || nextButton === observedButton) return;

      observer?.disconnect();
      observedButton = nextButton;
      hasBeenVisible = false;
      hideSticky();

      observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (!entry) return;

        if (entry.isIntersecting) {
          hasBeenVisible = true;
          hideSticky();
          return;
        }

        const mainButtonHasScrolledAboveViewport = entry.boundingClientRect.bottom <= 0;
        if (hasBeenVisible && mainButtonHasScrolledAboveViewport) {
          showSticky();
        } else {
          hideSticky();
        }
      }, {
        threshold: 0.05,
        rootMargin: '0px 0px 0px 0px'
      });

      observer.observe(nextButton);
    };

    bindToMainButton();

    const mutationObserver = new MutationObserver(() => {
      bindToMainButton();
      setLocalizedDynamicCheckoutLabel(document);
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  const initialize = () => {
    initializeStickyBuy();
    setLocalizedDynamicCheckoutLabel(document);

    document.querySelectorAll(dynamicCheckoutSelector).forEach((checkout) => {
      setLocalizedDynamicCheckoutLabel(checkout);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
